import { render, staticRenderFns } from "./custom-data-fields-form.vue?vue&type=template&id=6b230897"
import script from "./custom-data-fields-form.vue?vue&type=script&lang=js"
export * from "./custom-data-fields-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports